module.exports = __webpack_public_path__ + "img/five1Green.c49f009a.jpg";